<template>
  <div class="home-page bg" v-if="page">
    <div class="nav-box bg">
      <div class="logo">
        <img src="../../assets/images/login-logo.png" /> <span>哆视佳</span>
      </div>
      <div :class="{ 'nav-container': true, bottom: typeList.length === 0 }">
        <div
          :class="{ 'nav-item': true, 'is-click': curTrainType === 'all' }"
          @click="handleChangeTab"
        >
          <span>我的训练</span>
        </div>
        <div
          :class="{ 'nav-item': true, 'is-click': curTrainType === item.key }"
          v-for="(item, index) in navList"
          :key="index"
          @click="getCurTypeTrain(item, index)"
        >
          <span>{{ item.title }}</span>
        </div>
      </div>
      <div :class="{ signout: true, bottom: typeList.length === 0 }">
        <el-dropdown>
          <el-button round>
            {{ name }}<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              ><span class="wid100" @click="openUpdatePwdDialog"
                >修改密码</span
              ></el-dropdown-item
            >
            <el-dropdown-item
              ><span class="wid100" @click="handleLogout"
                >退出</span
              ></el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="main-box">
      <div class="expire" v-if="expire">
        温馨提示：您的账户已经到期，请及时充值。
      </div>
      <!-- todo 这是主页面 也就是为all的时候 -->
      <component
        :is="currentComponent"
        :trainTypeList="trainTypeList"
        @dialog-show="handleOpenDialog"
      ></component>
    </div>

    <el-dialog
      class="intro-dialog"
      :title="introForm.title"
      :visible.sync="introDialog"
      v-if="introDialog"
      center
      width="40%"
    >
      <div v-if="introForm.content" class="center">
        <p v-for="(item, index) in introForm.content" :key="index">
          {{ item }}
        </p>
      </div>
      <div v-else class="padding40">
        <div
          v-for="(item, index) in introForm.typeList"
          :key="index"
          class="type-item"
        >
          <h4 class="typeTitle">{{ item.typeName }}</h4>
          <div>
            <p
              class="textIdent"
              v-for="(content, index) in item.contents"
              :key="index"
            >
              {{ content }}
            </p>
          </div>
          <div class="typeImg-wrapper">
            <img
              class="typeImg"
              v-for="(src, index) in item.imgList"
              :key="index"
              :src="src"
            />
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="introDialog = false">关 闭</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="修改密码"
      :visible.sync="updatePwd"
      v-if="updatePwd"
      width="30%"
    >
      <el-form
        :model="pwdForm"
        :rules="loginFormjRules"
        ref="pwdForm"
        label-width="100px"
      >
        <el-form-item label="旧密码" prop="oldPassword">
          <el-input
            type="password"
            v-model="pwdForm.oldPassword"
            placeholder="请输入旧密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input
            type="password"
            v-model="pwdForm.newPassword"
            placeholder="请输入新密码"
            @change="newpwdChange"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirmPassword">
          <el-input
            type="password"
            v-model="pwdForm.confirmPassword"
            placeholder="请确认新密码"
            @change="confirmpwdChange"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleChange">确 定</el-button>
        <el-button @click="updatePwd = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
  <transition name="fade" mode="out-in" v-else>
    <router-view></router-view>
  </transition>
</template>

<script>
import { Vue, Component, Watch } from 'vue-property-decorator'
import { navList } from '@src/constant/nav'
import { homeIntroductions } from '@src/constant/home'
import homeTrain from '@src/components/homeTrain'
import { updatePwd } from '@api/login'
import loginFormjRules from '@utils/rules/loginFormRules'
import { validateForm } from '@utils'
import { encryption } from '@utils/crypto'

import { namespace } from 'vuex-class'

import TrainerGuide from './components/TrainerGuide.vue'
import MyTrain from './components/MyTrain.vue'
import MyAccount from './components/myaccount/index.vue'
const moduleTrain = namespace('train')
const moduleUser = namespace('user')

const componentList = ['MyTrain', 'TrainerGuide', 'MyAccount']
const allTypeList = [
  { name: '刺激训练', type: 'ST' },
  { name: '精细训练', type: 'EX' },
  { name: '多人训练', type: 'DR' },
  { name: '脱抑制训练', type: 'MFBF' },
  { name: '同时视训练', type: 'SV' },
  { name: '集合训练', type: 'FU' },
  { name: '散开训练', type: 'DV' },
  { name: '立体视训练', type: 'STE' },
]

@Component({
  components: { homeTrain, TrainerGuide, MyTrain, MyAccount },
})
export default class Home extends Vue {
  navList = navList
  page = true
  updatePwd = false
  pwdForm = {
    confirmPassword: '',
    newPassword: '',
    oldPassword: '',
  }
  typeList = []
  trainTypeList = []
  allTypeList = allTypeList
  curTrainType = 'all'
  currentComponent = 'MyTrain'
  homeIntroductions = homeIntroductions.slice(0, -1)
  introForm = {}
  introDialog = false
  componentList = componentList

  @moduleTrain.Mutation SET_TRAIN_TYPE_INFO
  @moduleUser.Action Logout
  @moduleUser.Action FeLogout
  @moduleUser.Getter name
  @moduleUser.Getter openDay
  @moduleUser.Getter usedDay

  created() {
    this.loginFormjRules = loginFormjRules
    if (this.$route.path === '/home') {
      this.page = true
    } else {
      this.page = false
    }

    this.trainTypeList = allTypeList.map(item => {
      return item.type
    })
  }

  @Watch('$route')
  onRouteChanged(val) {
    if (val.path === '/home') {
      this.page = true
      this.curTrainType = 'all'
      this.typeList = []
    }
  }

  get expire() {
    return this.usedDay > this.openDay
  }

  handleChangeTab() {
    this.curTrainType = 'all'
    this.typeList = []
    this.currentComponent = this.componentList[0]
  }

  handleTrainTypeList(value) {
    console.log(value)
  }

  handleOpenDialog(item) {
    console.log(item, '拿到的item')
    this.introForm = { ...item }
    this.introDialog = true
  }

  async handleLogout() {
    await this.Logout()
    location.reload()
  }

  openUpdatePwdDialog() {
    this.updatePwd = true
    this.pwdForm = {
      confirmPassword: '',
      newPassword: '',
      oldPassword: '',
    }
  }
  newpwdChange(value) {
    console.log(value)
    if (this.pwdForm.newPassword === this.pwdForm.oldPassword) {
      this.$message.warning('新密码和旧密码不能相同')
      return false
    } else {
      return true
    }
  }
  confirmpwdChange() {
    if (
      this.pwdForm.newPassword !== '' &&
      this.pwdForm.confirmPassword !== this.pwdForm.newPassword
    ) {
      this.$message.warning('确认密码和新密码输入不一致')
      return false
    } else {
      return true
    }
  }
  async handleChange() {
    const valid = await validateForm.call(this, 'pwdForm')
    valid && this.newpwdChange() && this.confirmpwdChange() && this.changePwd()
  }

  async changePwd() {
    const encryptOld = encryption({
      data: this.pwdForm,
      encryptArr: ['oldPassword'],
    })
    const encryptNew = encryption({
      data: this.pwdForm,
      encryptArr: ['newPassword'],
    })
    // console.log(encryptNew.newPassword, encryptOld.oldPassword)
    const res = await updatePwd({
      oldPassword: encryptOld.oldPassword,
      newPassword: encryptNew.newPassword,
    })
    if (res.code === 0) {
      this.updatePwd = false
      await this.FeLogout()
      location.reload()
    }
  }

  getCurTypeTrain(row, index) {
    this.typeList = []
    console.log(index, row, 'row的值')

    // todo 打开在线检查页面
    if (row.key === 'ksjc') {
      return window.open('https://exam.sgeye.com', 'exam')
    }
    // 赋值curTrainType
    this.currentComponent = this.componentList[index + 1]

    this.curTrainType = row.key
    Object.assign(this.typeList, row.trainArray)
    this.trainTypeList =
      row.trainArray.length > 0
        ? row.trainArray.map(item => {
            return item.type
          })
        : []
  }
  handleRedirectTo(row) {
    this.SET_TRAIN_TYPE_INFO(row)
    this.$router.push({ path: row.path })
    this.page = false
  }
}
</script>
<style lang="scss" scoped>
@import './index.scss';
.train-checkbox {
  .el-checkbox {
    color: #fff;
  }
}

.center {
  padding: 0 80px;
}
.padding40 {
  padding: 0 40px;
  .type-item {
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px dotted #ccc;
  }
  .typeTitle {
    margin: 0;
    font-size: 16px;
    line-height: 20px;
  }
  .textIdent {
    text-indent: 2em;
  }
  .typeImg-wrapper {
    display: flex;
    justify-content: space-around;
    .typeImg {
      width: 30%;
    }
  }
}
</style>
<style lang="scss">
.intro-dialog {
  .el-dialog__title {
    color: #585ad6;
  }
}
.el-button {
  height: 60px;
  font-size: 22px;
  i {
    padding-left: 24px;
  }
  padding: 20px 26px 38px !important;
}
</style>
